export default __webpack_public_path__ + "static/media/defaultAppIcon.9e3e30b1.svg";